exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#popup-container {\n  position: absolute;\n  top: -999px;\n  left: -999px;\n  z-index: 100;\n}\r\n", ""]);

// exports
